export default __webpack_public_path__ + "media/zurb/img/home/paloalto-1e1a6bd0be29dcbd40c833a056655fa0.svg";